/*eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
import { VueEditor } from "vue2-editor";
import {
mapGetters,
} from 'vuex';
export default {
  name: 'members-professional-categories',
  components: {
    VueEditor,
  },
  props: [],
  data () {
    return {
      submitted:false,
      display_name:'',
      createMemberFiltersPopup:false,
      getMemberFiltersListState:{},
      getMemberFiltersListResults:[],
      updateMemberFiltersPopup:false,
      updateMemberFiltersId:'',
      removeMemberFiltersPopup:false,
      removeMemberFiltersId:'',
      createProSubCatState:false,
      mainCatId:'',
      sub_category:'',
      removeProCatFilterId:'',
      removeProCatFilterPopup:false,
      updateProCatFilterId:'',
      updateProCatFilterPopup:false,
      lbilOptionLabel:false,
      lbilOptionParentToChildLabel:false,
      lbilSelectParent:'',
      getMemberMainFiltersListState:null,
      getMemberMainFiltersListResults:[],
      lbilOptionLabel:false,
      lbilOptionParentToChildLabel:false,
      lbilSelectParent:'',
      lbil_filter_img_key:null,
      lbil_filter_attachment_name:'',
      lbilOptionChildToParentLabel:'',
      lbil_display_name:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
    }
  },
  computed: {
    ...mapGetters([
      'getMemberMainFiltersByIdGetters',
      'getMemberMainFiltersGetters'
    ]),
    getMemberFiltersListFun(){
      this.getMemberFiltersListState = this.$store.getters.getMemberMainFiltersByIdGetters.data;
      return
    },
    getMemerFilterInitialStateFun(){
      if(this.getMemberFiltersListState != undefined){
        this.getMemberFiltersListResults = this.getMemberFiltersListState.category
      }
      return
    },
    getMemberMainFiltersListFun(){
      this.getMemberMainFiltersListState = this.$store.getters.getMemberMainFiltersGetters.data;
      return
    },
    getMemberMainFilterInitialStateFun(){
      if(this.getMemberMainFiltersListState != undefined){
        this.getMemberMainFiltersListResults = this.getMemberMainFiltersListState.results
      }
      return
    },
  },
  mounted () {
    this.getMemberFiltersListFun
    this.getMemerFilterInitialStateFun
    this.getMemberMainFiltersListFun
    this.getMemberMainFilterInitialStateFun
  },
  methods: {
    handleAttachmentUploadForLbil(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.lbil_filter_img_key = event.target.files[0];
        this.lbil_filter_attachment_name = this.lbil_filter_img_key.name
      }else {
        this.lbil_filter_attachment_name = '';
      }
    },
    getMemberFiltersListAgainMethod(){
      this.$store.dispatch('getMemberMainFilterDetailsByIdAction', {id:this.$route.params.filterId}).then((res) => {
        this.getMemberFiltersListState = res.data.data
      })
    },
    createMemberFiltersPopupFun(){
      this.createMemberFiltersPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeMemberFiltersPopupFun(){
      this.createMemberFiltersPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    createMemberFilterBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            category:this.display_name,
            member_category : this.$route.params.filterId
          }
          this.$store.dispatch('createMemberProfessionalFilterAction', data).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            // this.closeMemberFiltersPopupFun()
            this.display_name = ''
            this.$validator.reset();
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    updateMemberFiltersPopupEnabledFun(filterId,filterData){
      this.updateMemberFiltersId = filterId
      this.updateMemberFiltersPopup = true
      this.display_name = filterData.category
      $('body').addClass('body_right_scroll_remove')
    },
    closeUpdateMemberFiltersPopupFun(){
      this.updateMemberFiltersPopup = false
      this.updateMemberFiltersId = ''
      this.display_name = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    updateMemberFilterBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            category:this.display_name,
            member_category : this.$route.params.filterId
          }
          this.$store.dispatch('updateMemberProfessionalFilterAction',{data:{data:data,id:this.updateMemberFiltersId}}).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            this.closeUpdateMemberFiltersPopupFun()
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    removeMemberFiltersPopupEnabledFun(filterId){
      this.removeMemberFiltersId = filterId
      this.removeMemberFiltersPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeRemoveMemberFiltersPopupFun(){
      this.removeMemberFiltersPopup = false
      this.removeMemberFiltersId = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    removedMemberFiltersPopupFun(){
      this.$store.dispatch('deleteMemberProfessionalFilterAction',{id:this.removeMemberFiltersId}).then((res) => {
        toast.success(res.data.msg);
        this.getMemberFiltersListAgainMethod()
        this.closeRemoveMemberFiltersPopupFun()
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
    createProSubCatPopupFun(id){
      this.createProSubCatState = true
      this.mainCatId = id
      $('body').addClass('body_right_scroll_remove')
    },
    closeProSubCatPopupFun(){
      this.createProSubCatState = false
      this.mainCatId = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    createProSubCateBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            category:this.mainCatId,
            sub_category : this.sub_category
          }
          this.$store.dispatch('createMemberProfessionalSubFilterAction', data).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.sub_category = ''
            this.$validator.reset();
            this.getMemberFiltersListAgainMethod()
            // this.closeProSubCatPopupFun()
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    updateProSubCatPopupEnabledFun(filterId,filterData){
      this.sub_category = filterData.sub_category
      this.updateProCatFilterId = filterId
      this.updateProCatFilterPopup = true
      $('body').addClass('body_right_scroll_remove')
      this.lbilOptionParentToChildLabel = filterData.lbil_child || false
      if(filterData.lbil_image){
        if(filterData.lbil_image.split('/')[6]){
          this.lbil_filter_attachment_name = filterData.lbil_image.split('/')[6].split('?')[0]
        }else{
          this.lbil_filter_attachment_name = filterData.lbil_image.split('/')[5].split('?')[0]
        }
      }else{ 
        this.lbil_filter_attachment_name = ''
      }
      this.lbilSelectParent =  filterData.lbil_parent_key || ''
      this.lbilOptionChildToParentLabel = filterData.lbil_parent || false
      this.lbil_display_name = filterData.lbil_display_name || ''
      if(this.lbilOptionParentToChildLabel || this.lbilOptionChildToParentLabel){
        this.lbilOptionLabel = true
      }else{
        this.lbilOptionLabel = false
      }
    },
    closeUpdateProSubCatPopupFun(){
      this.resetAllKeysOfLbilFiters();
      this.updateProCatFilterPopup = false
      this.updateProCatFilterId = ''
      this.sub_category = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    resetAllKeysOfLbilFiters(){
      this.lbilOptionParentToChildLabel = false
      this.lbil_filter_img_key = null
      this.lbil_filter_attachment_name = ''
      this.lbilSelectParent = ''
      this.lbilOptionChildToParentLabel = false
    },
    updateProSubCateBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('sub_category', this.sub_category);
          formData.append('lbil_child', this.lbilOptionParentToChildLabel);
          formData.append('lbil_parent', this.lbilOptionChildToParentLabel);
          if(this.lbilOptionParentToChildLabel){
            if(this.lbilSelectParent != ''){
              formData.append('lbil_parent_key', this.lbilSelectParent);
            }
          }else{
            formData.append('lbil_parent_key', '');
          }
          if(this.lbil_filter_img_key != null){
            formData.append('lbil_image', this.lbil_filter_img_key);
          }
          if(this.lbil_display_name != null){
            formData.append('lbil_display_name', this.lbil_display_name);
          }
          if(this.lbilOptionChildToParentLabel){
            formData.append('lbil_child', false);
            formData.append('lbil_parent_key', '');
          }
          this.$store.dispatch('updateMemberProfessionalSubFilterAction',{data:{id:this.updateProCatFilterId,data:formData}}).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            this.closeUpdateProSubCatPopupFun()
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    removeProSubCatPopupEnabledFun(filterId){
      this.removeProCatFilterId = filterId
      this.removeProCatFilterPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeProSubCatPopupPopupFun(){
      this.removeProCatFilterPopup = false
      this.removeProCatFilterId = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    removedProSubCatPopupFun(){
      this.$store.dispatch('deleteMemberProfessionalSubFilterAction',{id:this.removeProCatFilterId}).then((res) => {
        toast.success(res.data.msg);
        this.getMemberFiltersListAgainMethod()
        this.closeProSubCatPopupPopupFun()
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
  },
  watch: {
    getMemberFiltersListFun(){
      return this.$store.getters.getMemberMainFiltersByIdGetters
    },
    getMemerFilterInitialStateFun(){
      if(this.getMemberFiltersListState != undefined){
        this.getMemberFiltersListResults = this.getMemberFiltersListState.results
      }
      return
    },
    getMemberMainFiltersListFun(){
      return this.$store.getters.getMemberMainFiltersGetters;
    },
    getMemberMainFilterInitialStateFun(){
      if(this.getMemberMainFiltersListState){
        this.getMemberMainFiltersListResults = this.getMemberMainFiltersListState.results
      }
      return
    },
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('body_right_scroll_remove')
    next();
  },
}